<template>
  <div>

    <page-heading-info
    title="Jefferson County Auto Title Department"
    phone="(740) 283-8509"
    ></page-heading-info>

    <div class="row">
      <div class="col-md-6 mt-3 order-1 order-md-0">
        <p>
        The Auto Title Deparment can Process Auto Titles for Ohio.
        License Plate service only when a title is purchased. Limited authority deputy registrar.
        Jefferson County offers two locations for your convenience.
        </p>
        <p>
          For any and all forms related to Auto Titling and license plates, please visit <a href="https://www.bmv.ohio.gov/forms-numerical.aspx" class="text-orange-4 link-hover">The State of Ohio Bureau of Motor Vehicles</a> to obtain forms.
        </p>

        <!--
        <hr class="mt-5 mb-4" style="border-top: 2px solid #cdcecf;" />

        <p>
          <strong class="text-danger">Notice: </strong> The Title Office located in the Jefferson County Courthouse will be closed 
          on Friday, January 14th due to renovations.
          <br /><br />
          The Rayland Office will be open during normal business hours on Friday, January 14th.
        </p>
        -->
      </div>

      <div class="col-md-6 mt-3 image-flex order-0 order-md-1">
        <img src="static/images/general/veterans_bridge_01.jpg" class="border-1 text-dark" />
      </div>
    </div>

    <!--<text-box-title title="Passport Processing" class="mt-3">
      <div class="col-md-6 mt-3">
        Passport Processing Information about passports and list a price for the passports
      </div>
    </text-box-title> -->

    <text-box-title title="Contacts" class="mt-3 justify-content-center">

      <div class="col-md-4 mt-3">
        <photo-info-card
        name="Angela Berdine"
        title="Title Office - Steubenville"
        phone="(740) 283-8509"
        ></photo-info-card>
      </div>

      <div class="col-md-4 mt-3">
        <photo-info-card
        name="Andrew D. Plesich"
        title="Clerk of Courts"
        phone="(740) 283-8509"
        ></photo-info-card>
      </div>

    </text-box-title>

    <hr class="mt-5" />

    <div class="service-list mt-5">
      <office-info
      hours-days="Monday thru Friday"
      hours="8:30AM to 4:10PM"
      floor="2nd Floor, Room 203"
      phone="(740) 283-8509"
      email="titleoffice@jeffcch.com"
      courthouse="true"
      title="Main Office"
      subtitle="County Courthouse"
      >
    </office-info>
    </div>

    <div class="service-list mt-3">
      <office-info
      hours-days="Monday thru Friday"
      hours="8:30AM to 4:10PM (closed 12:30PM-1:30PM)"
      floor=""
      phone="(740) 859-0411"
      email="titleoffice@jeffcch.com"
      title="Branch Location"
      subtitle="Rayland Branch"
      weekend="Saturday 8:30AM to 12:30PM *"
      caveat="* Unless holiday falls on preceding Friday or following Monday."
      >
      <address-simple
      line1="195 Main St. (rear)"
      line2="Rayland, Ohio 43943"
      ></address-simple>
    </office-info>
    </div>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo'
import PhotoInfoCard from '@/components/display-utils/PhotoInfoCard'
import OfficeInfo from '@/components/layout/OfficeInfo'
import TextBox from '@/components/layout/TextBox'
import TextBoxTitle from '@/components/layout/TextBoxTitle'
import AddressSimple from '@/components/display-utils/AddressSimple'

export default {
  components: {
    PageHeadingInfo,
    PhotoInfoCard,
    OfficeInfo,
    TextBox,
    TextBoxTitle,
    AddressSimple
  },
  data () {
    return {}
  },
  created: function() {
  }
}
</script>

<style scoped>
  .service-list ul li {
    font-size: 1.5em;
  }
</style>
